import { render } from "./TableProdutoAndMateria.vue?vue&type=template&id=16e3c60a"
import script from "./TableProdutoAndMateria.vue?vue&type=script&lang=js"
export * from "./TableProdutoAndMateria.vue?vue&type=script&lang=js"

import "./TableProdutoAndMateria.vue?vue&type=style&index=0&id=16e3c60a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__